import { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import AuthRoutes from './AuthRoutes';
import Login from '../components/pages/auth/Login';
import PrivateRoutes from './PrivateRoutes';
import Home from '../components/pages/home/Home';
import Details from '../components/pages/home/Details';

// const CommingSoonPage = lazy(() => import('../components/pages/CommingSoon'));
const ErrorPage = lazy(() => import('../components/pages/Error'));
// const QuestionnairePage = lazy(() => import('../components/pages/Questionnaire'));

// const Authentication = lazy(() => import('../components/older/Containers/Authentication'));
// const Activation = lazy(() => import('../components/older/Containers/Activation'));
// const Home = lazy(() => import('../components/older/Containers/Home'));

const NavigationRoutes = () => {
    return (
        <Routes>
            <Route element={<AuthRoutes />}>
                <Route element={<Login />} path='/login' />
            </Route>

            <Route element={<PrivateRoutes />}>
                <Route path='/' element={<Home />} />
                <Route path='/:id' element={<Details />} />
            </Route>

            <Route path="*" element={<ErrorPage />} />
        </Routes>
    )
};

export default NavigationRoutes;